import { render, staticRenderFns } from "./RoundedWikipediaIcon.vue?vue&type=template&id=66747f1a"
import script from "./RoundedWikipediaIcon.vue?vue&type=script&lang=js"
export * from "./RoundedWikipediaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports